﻿export const AcrMain = {
    async init() {
        // ileride global initler burada toplanabilir
    }
};

export function exposeAcrMain() {
    window.AcrMain = AcrMain;
}